/* -----------------Child components--------------- */
import DocumentTitle from "components/DocumentTitle";

import { pageViewTypes } from "@constants/tracking";
import { events } from "@constants/tracking";
import SessionContainer from "@features/session/screens/Session";
import useAnalytics from "@hooks/useAnalytics";
/* -----------------Globals--------------- */
import { Stack } from "expo-router";
import { useEffect, useMemo } from "react";
import { useOverlay } from "../../../providers/OverlayProvider";

const SessionRoute = () => {
	const { setOverlayOpen } = useOverlay();

	useEffect(() => {
		setOverlayOpen(false);
	}, [setOverlayOpen]);

	const memoizedAnalytics = useMemo(() => {
		return {
			type: pageViewTypes.session,
			eventName: events.sessionViewed,
		};
	}, []);

	useAnalytics(memoizedAnalytics);

	return (
		<>
			<Stack.Screen
				options={{
					headerShown: false,
				}}
			/>
			<DocumentTitle title="Session" />
			<SessionContainer />
		</>
	);
};

export default SessionRoute;
